// 広告タグの表示に関する処理を提供する
//
//  e.g.
//  ```
//  <div id="div-gpt-ad-1473215132261-0" class="ads-element" data-ads-path="/62539033/PCトップパネル(上)" data-ads-dimensions="[300, 250]" style="min-height: 250px;"></div>
//  ```
//
//  refs.
//   * https://gist.github.com/kinopyo/8271d61d979247b7f9a7c43e5cd4f910
//   * http://reed.github.io/turbolinks-compatibility/doubleclick_for_publishers.html
const slots = {};

const getDimensions = (element) => {
  return JSON.parse(element.getAttribute('data-ads-dimensions'));
};

// 広告の定義処理
const defineSlot = (slot) => {
  const divId = slot.getAttribute('id');
  const path = slot.getAttribute('data-ads-path');
  const dimensions = getDimensions(slot);
  window.googletag.cmd.push(() => {
    const slot = window.googletag.defineSlot(path, dimensions, divId)
    if (!slot) return;

    slot.addService(window.googletag.pubads());
    window.googletag.enableServices();
    window.googletag.display(divId);
    slots[divId] = slot;
  });
}

// ロード時に広告を表示する
// すでに一度表示されている場合はキャッシュからリフレッシュする
document.addEventListener('turbolinks:load', () => {
  const googleAdTags = document.querySelectorAll('[data-ads-path]');
  if (!googleAdTags) return;

  for (let i = 0; i < googleAdTags.length; i += 1) {
    const googleAdTag = googleAdTags[i];
    const cachedSlot = slots[googleAdTag.getAttribute('id')];

    if (cachedSlot) {
      window.googletag.cmd.push(() => window.googletag.pubads().refresh([cachedSlot]));
    } else {
      defineSlot(googleAdTag)
    }
  }
});

// リクエスト前に広告をリセット
document.addEventListener('turbolinks:request-start', () => {
  if (!window.googletag) return;

  window.googletag.cmd.push(() => window.googletag.pubads().clear());
});
